import { Observable, Subject } from 'common/barrels/rx';

export function and(a: Observable<boolean>, b: Observable<boolean>) {
    return a.combineLatest(b, (x, y) => x && y).distinctUntilChanged();
}

export function functionObservablePair<T>(): [(x :T) => void, Observable<T>] {
    const s = new Subject<T>();
    const f = (z: T) => s.next(z);

    return [f, s.asObservable()];
}

export function voidFunctionObservablePair(): [() => void, Observable<void>] {
    const s = new Subject<void>();
    const f = () => s.next();

    return [f, s.asObservable()];
}